import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FRONT_PAGE_PATH } from "constants/paths";
import { Link } from "react-router-dom";
import NOB from '../../constants/language-strings';
import { Icon } from "@purpurds/purpur/icon";
import { icons } from "theme/icons";
import spacing from "theme/spacing";
import styled from "styled-components";
import { purpurColorOrange100, purpurColorOrange600, purpurColorRed100, purpurColorRed600, } from "@purpurds/tokens/color/variables";
const variants = {
    error: {
        bg: purpurColorRed100,
        text: purpurColorRed600,
        border: purpurColorRed600,
        icon: icons.error,
    },
    info: {
        bg: purpurColorOrange100,
        text: purpurColorOrange600,
        border: purpurColorOrange600,
        icon: icons.info,
    },
};
const MessageContainer = styled.div `
  display: flex;
  align-items: center;
  padding: ${spacing.spacing12};
  border-radius: 4px;
  margin-top: ${spacing.spacing8};
  gap: 8px;

  background-color: ${({ variant }) => variants[variant].bg};
  color: ${({ variant }) => variants[variant].text};
  border: 1px solid ${({ variant }) => variants[variant].border};
`;
const Content = styled.div `
  display: flex;
  flex-direction: column;
`;
const Text = styled.div `
  display: flex;
  align-items: center;
`;
const StyledIcon = styled(Icon) `
  width: 28px;
  height: 28px;
  color: ${({ variant }) => variants[variant].text};
`;
const StyledLink = styled(Link) `
  font-style: italic;
  text-decoration: underline;
  color: ${({ variant }) => variants[variant].text};
`;
export const InfoBox = ({ firstInfoBoxLine, secondInfoBoxLine, link = false, variant = "error", }) => {
    const currentVariant = variants[variant];
    return (_jsxs(MessageContainer, { variant: variant, children: [_jsx(StyledIcon, { svg: currentVariant.icon, variant: variant }), _jsxs(Content, { children: [_jsx(Text, { children: firstInfoBoxLine }), !!secondInfoBoxLine && _jsx(Text, { children: secondInfoBoxLine }), link && (_jsx(StyledLink, { to: FRONT_PAGE_PATH, variant: variant, children: NOB.NO_WORK_ORDERS.TO_FRONT_PAGE }))] })] }));
};
